import { render } from "./SignOutBar.vue?vue&type=template&id=a948d5fe"
import script from "./SignOutBar.vue?vue&type=script&lang=js"
export * from "./SignOutBar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/joecortinhas/Documents/code/DigitalLaborSolutions/dlstracker_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__